<template>
  <div class="index-page">
    <div class="page-title">
      <p class="title">
        标签管家
      </p>
    </div>
    <div class="printer">
      <p class="name">
        {{ device && device.name ? device.name : '尚未连接' }}
      </p>
      <div class="select" @click="$router.push('/device')">
        <img
          class="icon"
          :src="
            device && device.name
            ? printerActiveIcon
            : printerIcon
          "
        />
        <p class="text" :class="{ 'active' : device && device.name }">
          {{ device && device.name ? '已连接' : '连接打印机' }}
        </p>
      </div>
    </div>
    <div class="swiper">
      <van-swipe
        :autoplay="5000"
        indicator-color="#fff"
      >
        <van-swipe-item
          v-for="item in banners"
          :key="item.id"
        >
          <van-image
            class="banner-image"
            :lazy-load="true"
            :src="item.image"
            @click="openUrl(item)"
          />
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="short-cuts">
      <div class="item" @click="$router.push('/record')">
        <img
          class="icon"
          src="@/assets/image/index/record.png"
        />
        <div class="text">
          <p class="title">
            打印历史
          </p>
          <p class="des">
            查看标签打印记录 
          </p>
        </div>
      </div>
      <div class="item" @click="$router.push('/statistic')">
        <img
          class="icon"
          src="@/assets/image/index/statistic.png"
        />
        <div class="text">
          <p class="title">
            打印统计
          </p>
          <p class="des">
            分析标签打印数据
          </p>
        </div>
      </div>
    </div>

    <div class="record">
      <div class="wrapper">
        <div class="head">
          <div class="export"></div>
          <img src="@/assets/image/index/paper.png" class="paper">
          <p class="title">
            最近打印
          </p>
        </div>
        <p v-if="!record.length" class="no-record">
          没有更多了
        </p>
        <template
          v-for="(item, index) in record"
        >
          <RecordItem
            :key="index"
            :item="item"
            @handleClick="goPage(item)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {  getAllRecord } from '@/api/tag';
import { getBanners } from '@/api/system';
import RecordItem from '@/components/RecordItem';
const Banner = require('@/assets/image/banner.png');
const printerIcon = require('@/assets/image/printer.png');
const printerActiveIcon = require('@/assets/image/printer-active.png');
export default {
  name: 'Index',
  components: {
    RecordItem
  },
  data() {
    return {
      defaultBanner: {
        url: 'https://shop127591181.m.youzan.com/v2/showcase/homepage?alias=MhL86lL0cU', // 有赞商城
        image: Banner
      },
      printerIcon,
      printerActiveIcon,
      record: [],
      banners: []
    }
  },
  computed: {
    ...mapGetters([ 'device' ]),
  },
  created() {
    this.getBanner()
    this.getRecentRecord()
  },
  methods: {
    getRecentRecord() {
      const query = {
        per_page: 5,
        page: 1
      }

      getAllRecord(query)
      .then(res => {
        if (res) {
          const { data } = res

          this.record = data
        }
      })
    },
    goPage(item) {
      const { tag_id, id, is_delete } = item
      if (is_delete == 1) {
        this.$Toast.fail('该标签模版已被禁用，无法打印！')

        return
      }

      const path = `/print/${tag_id}?t=${id}`
      this.$router.push(path)
    },
    openUrl(item) {
      const { url }  = item
      if (!url) return

      this.$utils.app.openUrl(url)
    },
    getBanner() {
      getBanners({ status: 1 })
      .then(res => {
        if (res) {
          this.banners = res.length ? res : [ this.defaultBanner ]
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .index-page {
    padding: 0 0 60px;
  }
  .page-title {
    height: 110px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .title {
      font-size: 48px;
      font-weight: 600;
      color: @primary-font-color-1;
    }
  }
  .printer {
    display: flex;
    align-items: flex-end;
    padding: 24px 66px;
    .name {
      color: @primary-font-color-1;
      font-size: 40px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .select {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      margin: 0 0 0 40px;
      .icon {
        width: 64px;
        height: auto;
        margin: 0 0 16px 0;
      }
      .text {
        color: #FEFEFE;
        font-size: 40px;
        &.active {
          color: @primary-color-1;
        }
      }
    }
  }
  .swiper {
    width: 100%;
    padding: 0 64px;
    height: 526px;
  }
  .banner-image, .van-swipe {
    width: 100%;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
  }
  .short-cuts {
    padding: 0 64px;
    margin: 40px 0;
    display: flex;
    // gap: 30px;
    .flexgap(30px, row);
    .item {
      flex: 1;
      height: 320px;
      background-color: rgba(255, 255, 255, 0.5);
      display: flex;
      padding: 0 0 0 50px;
      align-items: center;
      border-radius: 6px;
      box-shadow: 0px 0px 6px 1px rgba(181, 248, 251, 0.2);
      .icon {
        width: 120px;
        height: 140px;
      }
      .text {
        margin: 0 0 0 24px;
        .title {
          font-size: 42px;
          color: #333;
          font-weight: 600;
          margin: 0 0 14px 0;
        }
        .des {
          font-size: 30px;
          color: #707070;
        }
      }
    }
  }
  .record {
    padding: 0 64px;
    .wrapper {
      padding: 0 0 20px;
      .head {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        height: 114px;
        .export {
          width: 100%;
          height: 34px;
          background-color: #898989;
          border-radius: 17px;
          position: absolute;
          top: 0;
        }
        .paper {
          position: absolute;
          width: 100%;
          height: 98px;
          top: 16px;
        }
        .title {
          width: 100%;
          position: absolute;
          font-size: 46px;
          color: #333;
          font-weight: bold;
          text-align: center;
          bottom: 0px;
        }
      }
      .no-record {
        padding: 40px;
        font-size: 44px;
        color: @font-gray-1;
        text-align: center;
      }
    }
  }
</style>